import './OptInToMarketingConsent.scss';

import { Body, ButtonV2, Icon, Title } from '@travelwin/core';
import { Trans } from 'react-i18next';

import { useConsent } from '@/context/Consent';

const className = 'c-OptInToMarketingConsent';

export const OptInToMarketingConsent = () => {
  const { consentToMarketingCookies } = useConsent();

  return (
    <div className={className}>
      <div className={`${className}__heading`}>
        <Icon name="info" />
        <Title tag={3} level={5} className="text-center" color="white">
          <Trans
            i18nKey="youtube-wrapper.need-consent.title"
            defaults="This content requires marketing cookies"
          />
        </Title>
      </div>
      <div className="separator-16" />
      <Body
        className={`${className}__context text-center`}
        accent="title"
        color="white"
      >
        <Trans
          i18nKey="youtube-wrapper.need-consent.context"
          defaults="By clicking 'Accept & Play', you consent to YouTube's cookie usage for video playback."
        />
      </Body>
      <div className="separator-32" />
      <ButtonV2
        intent="destructive-red"
        variant="primary"
        icons={{ leading: <Icon name="play" /> }}
        onClick={consentToMarketingCookies}
      >
        <Trans
          i18nKey="youtube-wrapper.need-consent.cta"
          defaults="Accept & Play"
        />
      </ButtonV2>
    </div>
  );
};
